import { Routes as Rotas, Route } from 'react-router-dom';

import Layout from '../layout/mainLayout';
import TitularArrendatario from '../pages/TitularArrendatario/TitularArrendatario';
import DiefCfem from '../pages/DiefCfem';
import PrimeiroAdquirente from '../pages/PrimeiroAdquirente/PrimeiroAdquirente';
import PrimeiroAdquirenteEdit from '../pages/PrimeiroAdquirente/PrimeiroAdquirenteEdit/PrimeiroAdquirenteEdit';
import PrimeiroAdquirenteView from '../pages/PrimeiroAdquirente/PrimeiroAdquirenteView/PrimeiroAdquirenteView';
import HastaPublica from '../pages/HastaPublica/HastaPublica';
import Login from '../pages/Login/Login';
import Logout from '../pages/Logout/Logout';
import HeaderFooterLayout from '../layout/headerFooterLayout';
import HastaPublicaEdit from '../pages/HastaPublica/HastaPublicaEdit/HastaPublicaEdit';
import HastaPublicaView from '../pages/HastaPublica/HastaPublicaView/HastaPublicaView';
import TitularArrendatarioEdit from '../pages/TitularArrendatario/TitularArrendatarioEdit/TitularArrendatarioEdit';
import TitularArrendatarioView from '../pages/TitularArrendatario/TitularArrendatarioView/TitularArrendatarioView';
import ProtectedRoute from './protectedRoute';
import { ENaturezaDocumentacao } from '../enums/ENaturezaDocumentacao';

const Routes = () => {
  const isCnpjNaoFilial = () => {
    return sessionStorage.getItem('naturezaDocumentacao') !== ENaturezaDocumentacao.CNPJ_FILIAL;
  };

  return (
    <Rotas>
      <Route element={<HeaderFooterLayout />}>
        <Route path='login' element={<Login />} />
        <Route element={<Layout />}>
          <Route index element={<DiefCfem />} />
          <Route path='logout' element={<Logout />} />
          <Route
            path='titular-ou-arrendatario'
            element={
              <ProtectedRoute checkAccess={() => isCnpjNaoFilial()} fallbackPath='/'>
                <TitularArrendatario />
              </ProtectedRoute>
            }
          />
          <Route
            path='titular-ou-arrendatario/edit'
            element={
              <ProtectedRoute checkAccess={() => isCnpjNaoFilial()} fallbackPath='/'>
                <TitularArrendatarioEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path='titular-ou-arrendatario/view'
            element={
              <ProtectedRoute checkAccess={() => isCnpjNaoFilial()} fallbackPath='/'>
                <TitularArrendatarioView />
              </ProtectedRoute>
            }
          />
          <Route
            path='primeiro-adquirente'
            element={
              <ProtectedRoute checkAccess={() => isCnpjNaoFilial()} fallbackPath='/'>
                <PrimeiroAdquirente />
              </ProtectedRoute>
            }
          />
          <Route
            path='primeiro-adquirente/edit'
            element={
              <ProtectedRoute checkAccess={() => isCnpjNaoFilial()} fallbackPath='/'>
                <PrimeiroAdquirenteEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path='primeiro-adquirente/view'
            element={
              <ProtectedRoute checkAccess={() => isCnpjNaoFilial()} fallbackPath='/'>
                <PrimeiroAdquirenteView />
              </ProtectedRoute>
            }
          />
          <Route path='hasta-publica' element={<HastaPublica />} />
          <Route path='hasta-publica/edit' element={<HastaPublicaEdit />} />
          <Route path='hasta-publica/view' element={<HastaPublicaView />} />
        </Route>
      </Route>
    </Rotas>
  );
};

export default Routes;
